import EpisodeDeleteModal from "./episode_delete_modal";
import EpisodeDeleteActionManager from "../../action_managers/episode_delete";
import { hideModal } from "../../actions/modal";
import { connect } from "react-redux";
import { withRouter } from "react-router";

function mapStateToProps(state) {
  return {
    user: state.user.user,
    isLoading: state.episodeDelete.isLoading,
    errorMessage: state.episodeDelete.errorMessage,
    isSuccess: state.episodeDelete.isSuccess,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    closeModal: () => {
      dispatch(hideModal());
    },
    deleteEpisode: (episode, user) => {
      return dispatch(
        new EpisodeDeleteActionManager({
          episode,
          authToken: user.authToken,
        }).run()
      );
    },
  };
}

const EpisodeDeleteModalWrapper = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EpisodeDeleteModal)
);

export default EpisodeDeleteModalWrapper;
